import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import SummaryReportLayer from "../../components/Trading/SummaryReportLayer";

const SummaryReportPage = () => {
  return (
    <MasterLayout>
      <SummaryReportLayer />
    </MasterLayout>
  );
};

export default SummaryReportPage;
